var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{attrs:{"type":_vm.statusColor,"size":"is-small"}},[_vm._v(_vm._s(_vm.statusText))])}
var staticRenderFns = []

export { render, staticRenderFns }